import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from '@progress/kendo-react-layout';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import api from '../../../utils/api';
import { SaltedPatientWorkoutDetail } from '../../../store/types/SaltedPatientWorkoutDetail';
import '../PatientPage.css';

interface SaltedPatientWorkoutDetailProps {
  ptCd: string;
  id: number
  workoutUuid: string;
}

const SaltedPatientWorkoutDetailComponent: React.FC<SaltedPatientWorkoutDetailProps> = (
  props
) => {
  const user = useSelector((state: RootState) => state.user.user);
  const [SaltedPatientWorkoutDetail, setSaltedPatientWorkoutDetail] =
    useState<SaltedPatientWorkoutDetail | null>(null);

  useEffect(() => {
    const fetchSaltedPatientWorkoutDetail = async () => {
      if (user?.hospital?.hspCd) {
        try {
          const response = await api.getSaltedPatientWorkoutDetail(
            props.ptCd,
            props.id,
            user.hospital.hspCd
          );
          setSaltedPatientWorkoutDetail(response.data);
        } catch (error) {
          console.error('Error fetching WorkoutDetail:', error);
        }
      }
    };

    fetchSaltedPatientWorkoutDetail();
  }, [props.id]);

  return (
    <div className="recordContainer">
      <Card>
        <CardHeader>
          <CardTitle>
            Workout props - {SaltedPatientWorkoutDetail?.workoutCode}
          </CardTitle>
        </CardHeader>
        <CardBody>
          <p>
            <strong>Patient Code:</strong> {props.ptCd}
          </p>
          <p>
            <strong>Workout UUID:</strong> {props.workoutUuid}
          </p>
          <p>
            <strong>Phi Code:</strong> {SaltedPatientWorkoutDetail?.phiCode || '-'}
          </p>
          <p>
            <strong>Workout Time:</strong>{' '}
            {SaltedPatientWorkoutDetail?.workoutTime != null
              ? `${SaltedPatientWorkoutDetail.workoutTime} millisecond`
              : ''}
          </p>
          <p>
            <strong>Step Count:</strong>{' '}
            {SaltedPatientWorkoutDetail?.stepCount != null
              ? `${SaltedPatientWorkoutDetail.stepCount} step`
              : ''}
          </p>
          <p>
            <strong>Cadence:</strong>{' '}
            {SaltedPatientWorkoutDetail?.cadence != null
              ? `${SaltedPatientWorkoutDetail.cadence} step/min`
              : ''}
          </p>q
          <PanelBar>
            <PanelBarItem title="Ground Contact Time">
              <p>
                <strong>Right:</strong>{' '}
                {SaltedPatientWorkoutDetail?.rightGroundContactTime != null
                  ? `${SaltedPatientWorkoutDetail.rightGroundContactTime} second`
                  : ''}
              </p>
              <p>
                <strong>Left:</strong>{' '}
                {SaltedPatientWorkoutDetail?.leftGroundContactTime != null
                  ? `${SaltedPatientWorkoutDetail.leftGroundContactTime} second`
                  : ''}
              </p>
            </PanelBarItem>
            <PanelBarItem title="Stance Phase Mean">
              <p>
                <strong>Right:</strong>{' '}
                {SaltedPatientWorkoutDetail?.stancePhaseRightMean != null
                  ? `${SaltedPatientWorkoutDetail.stancePhaseRightMean}%`
                  : ''}
              </p>
              <p>
                <strong>Left:</strong>{' '}
                {SaltedPatientWorkoutDetail?.stancePhaseLeftMean != null
                  ? `${SaltedPatientWorkoutDetail.stancePhaseLeftMean}%`
                  : ''}
              </p>
            </PanelBarItem>

            <PanelBarItem title="Swing Phase Mean">
              <p>
                <strong>Right:</strong>{' '}
                {SaltedPatientWorkoutDetail?.swingPhaseRightMean != null
                  ? `${SaltedPatientWorkoutDetail.swingPhaseRightMean}%`
                  : ''}
              </p>
              <p>
                <strong>Left:</strong>{' '}
                {SaltedPatientWorkoutDetail?.swingPhaseLeftMean != null
                  ? `${SaltedPatientWorkoutDetail.swingPhaseLeftMean}%`
                  : ''}
              </p>
            </PanelBarItem>

            <PanelBarItem title="Single Support Mean">
              <p>
                <strong>Right:</strong>{' '}
                {SaltedPatientWorkoutDetail?.singleSupportRightMean != null
                  ? `${SaltedPatientWorkoutDetail.singleSupportRightMean}%`
                  : ''}
              </p>
              <p>
                <strong>Left:</strong>{' '}
                {SaltedPatientWorkoutDetail?.singleSupportLeftMean != null
                  ? `${SaltedPatientWorkoutDetail.singleSupportLeftMean}%`
                  : ''}
              </p>
            </PanelBarItem>

            <PanelBarItem title="Double Support Mean">
              <p>
                <strong>Right:</strong>{' '}
                {SaltedPatientWorkoutDetail?.doubleSupportRightMean != null
                  ? `${SaltedPatientWorkoutDetail.doubleSupportRightMean}%`
                  : ''}
              </p>
              <p>
                <strong>Left:</strong>{' '}
                {SaltedPatientWorkoutDetail?.doubleSupportLeftMean != null
                  ? `${SaltedPatientWorkoutDetail.doubleSupportLeftMean}%`
                  : ''}
              </p>
            </PanelBarItem>
          </PanelBar>

          <p>
            <strong>Progress Percentage:</strong>{' '}
            {SaltedPatientWorkoutDetail?.progressPercentage}%
          </p>
        </CardBody>
      </Card>
    </div>
  );
};

export default SaltedPatientWorkoutDetailComponent;
